import { ADDPURCHASEORDER, UPDATEPURCHASEORDER } from "../../utils/api";
import axios from "../../utils/axios";

export const addPurchaseOrder = async (payload) => {
  const res = await axios.post(ADDPURCHASEORDER, payload);
  return res;
};

export const updatePurchaseOrder = async (payload) => {
  const res = await axios.post(UPDATEPURCHASEORDER, payload);
  return res;
};
